import { colors } from 'ui/theme/colors';

import { BrandAffinityLevel } from 'modules/domains/brandAffinity/BrandAffinityLevel';

export const BRAND_AFFINITY_LEVEL_COLORS: Record<BrandAffinityLevel, { bg: string; text: string }> =
  {
    [BrandAffinityLevel.LOYAL]: { bg: colors.lavenderLighten40, text: colors.purple100 },
    [BrandAffinityLevel.NEGATIVE]: { bg: colors.lavenderLighten40, text: colors.purple100 },
    [BrandAffinityLevel.NEUTRAL]: { bg: colors.lavenderLighten40, text: colors.purple100 },
    [BrandAffinityLevel.POSITIVE]: { bg: colors.lavenderLighten40, text: colors.purple100 },
    [BrandAffinityLevel.UNSCORED]: { bg: colors.lavenderLighten100, text: colors.purple100 },
  };

export const BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE: Record<BrandAffinityLevel, number> = {
  [BrandAffinityLevel.LOYAL]: 100,
  [BrandAffinityLevel.NEGATIVE]: 25,
  [BrandAffinityLevel.NEUTRAL]: 50,
  [BrandAffinityLevel.POSITIVE]: 75,
  [BrandAffinityLevel.UNSCORED]: 0,
};
